// src/ebay_oauth_callback.js

import { fetchCardData } from '../data/update_operations.js';
import { setupAuthentication } from '../auth.js';
import config from '../../config';
import { setupUserToken } from '../auth_utils.js';

// Handle successful login and process eBay OAuth callback
const handleLoginSuccess = async (user, token) => {
  const headers = setupUserToken(token);
  const newHeaders = { ...headers, 'Content-Type': 'application/json' };

  const params = new URLSearchParams(window.location.search);
  const authCode = params.get('code');
  const state = params.get('state');
  const storedState = localStorage.getItem('oauth_state'); // Assuming state is stored in localStorage

  if (state !== storedState) {
    alert('State mismatch. Possible CSRF attack.');
    return;
  }

  if (authCode) {
    try {
      // Send the authorization code to the backend server
      const payload = { code: authCode };
      const response = await fetchCardData(
        `${config.detectionUrl}/exchange-ebay-token`,
        'POST',
        newHeaders,
        payload
      );

      if (response.body.success) {
        alert('eBay account connected successfully!');
        window.location.href = '/integrations.html'; // Redirect to desired page
      } else {
        alert('Error connecting eBay account: ' + data.error);
      }
    } catch (error) {
      console.error('Error exchanging eBay token:', error);
      alert('An error occurred while connecting your eBay account.');
    }
  } else {
    alert('Authorization failed. No code returned.');
  }
};

// Handle login failure
function handleLoginFailure() {
  alert('Authentication failed. Please log in again.');
  window.location.href = '/login.html'; // Redirect to login page if needed
}

// Initialize the OAuth callback handling
export async function handleOAuthCallback() {
  setupAuthentication(handleLoginSuccess, handleLoginFailure);
}
